// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1-yZ7","inner":"Footer_inner__2UtJ9"};